import script from "./PasswordResetForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordResetForm.vue?vue&type=script&setup=true&lang=js"

import "./PasswordResetForm.vue?vue&type=style&index=0&id=e859d506&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e859d506"]])

export default __exports__